import { render, staticRenderFns } from "./DeviceDet.vue?vue&type=template&id=5eda32c1&scoped=true&"
import script from "./DeviceDet.vue?vue&type=script&lang=ts&"
export * from "./DeviceDet.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDet.vue?vue&type=style&index=0&id=5eda32c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda32c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VRow,VSimpleTable})
